var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlavor1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.112 7.72668C8.32577 6.51391 9.9411 5.57166 11.3313 4.89689C10.5921 3.01239 9.35702 1.27683 8.60868 0.313303C8.26189 -0.0970311 7.64132 -0.109189 7.30669 0.313303C6.20243 1.74491 4 4.91817 4 7.67197C4 9.31938 4.34679 10.5352 4.90957 11.3771C5.1286 10.6841 5.46322 9.95768 5.94082 9.17957C6.24502 8.68108 6.64657 8.19476 7.112 7.72668Z",
    fill: "#A36129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8449 5.98178C14.7901 5.44986 14.2486 5.12463 13.7589 5.31004C12.0584 5.95138 8.53264 7.52281 7.09072 9.87235C5.15903 13.0365 5.85261 15.2888 7.72955 16.4255C9.59431 17.5532 11.9276 17.152 13.8471 14C15.289 11.6474 15.0517 7.79029 14.8449 5.98178Z",
    fill: "#A36129"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 17,
    fill: "white",
    transform: "translate(4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlavor1);
export default __webpack_public_path__ + "static/media/flavor_1.263c5a8c9d3bd5189fe48adc43d8f7a5.svg";
export { ForwardRef as ReactComponent };